import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './_theme';
import Navigation from './Navigation';
import WithLoadingHandler from 'hoc/withLoadingHandler/withLoadingHandler';
import JobCategorySearchView from './JobCategory/SearchView';
import JobCategoryEditorView from './JobCategory/EditorView';
import JobCategoryMappingSearchView from './JobCategoryMapping/SearchView';
import JobCategoryMappingEditorView from './JobCategoryMapping/EditorView';
import JobCategoryMappingNewView from './JobCategoryMapping/NewView';
import SecurityFormView from './Security/FormView';
import SecuritySummaryView from './Security/SummaryView';
import TrainingTrackSearchView from './TrainingTrack/SearchView';
import TrainingTrackEditorView from './TrainingTrack/EditorView';
import BulkUploadEditorView from './BulkUpload/EditorView';
import UserSearchView from './User/SearchView';
import UserDetailsView from './User/DetailsView';
import PrivilegedView from './components/PrivilegedView';
import { useAzureAuthorized } from './useAzureAuthorized';
import { PERMISSIONS } from './_const';

const EpicAdministrationRoutes = () => {
	const { path } = useRouteMatch();
	const permissions = {
		roles: [PERMISSIONS.IMS_ROLE, PERMISSIONS.BRIDGES_ROLE],
		privileges: [PERMISSIONS.BRIDGES_PRIVILEGE],
	};

	function Home() {
		const isAzureAuthorized = useAzureAuthorized(PERMISSIONS.CT_GROUP);
		return isAzureAuthorized != null ? (
			isAzureAuthorized ? (
				<Navigation />
			) : (
				<PrivilegedView
					pageID='EPIC_ADMINISTRATION_HOME'
					{...permissions}
				>
					<Navigation />
				</PrivilegedView>
			)
		) : (
			<WithLoadingHandler isLoading />
		);
	}

	function UserSearch() {
		const isAzureAuthorized = useAzureAuthorized(PERMISSIONS.CT_GROUP);
		return isAzureAuthorized != null ? (
			isAzureAuthorized ? (
				<UserSearchView isAzureAuthorized />
			) : (
				<PrivilegedView
					pageID='EPIC_ADMINISTRATION_USER_SEARCH'
					{...permissions}
				>
					<UserSearchView isRoleAuthorized />
				</PrivilegedView>
			)
		) : (
			<WithLoadingHandler isLoading />
		);
	}

		function UserDetails() {
			const isAzureAuthorized = useAzureAuthorized(PERMISSIONS.CT_GROUP);
			return isAzureAuthorized != null ? (
				isAzureAuthorized ? (
					<UserDetailsView
						isAzureAuthorized
					/>
				) : (
					<PrivilegedView
						pageID='EPIC_ADMINISTRATION_USER_SEARCH'
						{...permissions}
					>
						<UserDetailsView
							isRoleAuthorized
						/>
					</PrivilegedView>
				)
			) : (
				<WithLoadingHandler isLoading />
			);
		}

	return (
		<ThemeProvider theme={theme}>
			<Switch>
				<Route path={`${path}/Home`} exact render={() => <Home />} />
				<Route
					path={`${path}/JobCategory/Edit`}
					exact
					render={props => (
						<PrivilegedView
							pageID='EPIC_ADMINISTRATION_JOB_EDIT'
							{...permissions}
						>
							<JobCategoryEditorView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route
					path={`${path}/JobCategory/New`}
					exact
					render={props => (
						<PrivilegedView
							pageID='EPIC_ADMINISTRATION_JOB_NEW'
							{...permissions}
						>
							<JobCategoryEditorView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route
					path={`${path}/JobCategory/Search`}
					exact
					render={props => (
						<PrivilegedView
							pageID='EPIC_ADMINISTRATION_JOB_SEARCH'
							{...permissions}
						>
							<JobCategorySearchView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route
					path={`${path}/JobCategoryMapping/Edit`}
					exact
					render={props => (
						<PrivilegedView
							pageID='EPIC_ADMINISTRATION_MAP_EDIT'
							{...permissions}
						>
							<JobCategoryMappingEditorView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route
					path={`${path}/JobCategoryMapping/New`}
					exact
					render={props => (
						<PrivilegedView
							pageID='EPIC_ADMINISTRATION_MAP_NEW'
							{...permissions}
						>
							<JobCategoryMappingNewView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route
					path={`${path}/JobCategoryMapping/Search`}
					exact
					render={props => (
						<PrivilegedView
							pageID='EPIC_ADMINISTRATION_MAP_SEARCH'
							{...permissions}
						>
							<JobCategoryMappingSearchView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route
					path={`${path}/TrainingTrack/Edit`}
					exact
					render={props => (
						<PrivilegedView
							pageID='EPIC_ADMINISTRATION_TRAINING_EDIT'
							{...permissions}
						>
							<TrainingTrackEditorView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route
					path={`${path}/TrainingTrack/New`}
					exact
					render={props => (
						<PrivilegedView
							pageID='EPIC_ADMINISTRATION_TRAINING_NEW'
							{...permissions}
						>
							<TrainingTrackEditorView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route
					path={`${path}/TrainingTrack/Search`}
					exact
					render={props => (
						<PrivilegedView
							pageID='EPIC_ADMINISTRATION_TRAINING_SEARCH'
							{...permissions}
						>
							<TrainingTrackSearchView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route
					path={`${path}/BulkUpload/Upload`}
					exact
					render={props => (
						<PrivilegedView
							pageID='EPIC_ADMINISTRATION_BULK_UPLOAD'
							{...permissions}
						>
							<BulkUploadEditorView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route
					path={`${path}/User/Search`}
					exact
					render={() => <UserSearch />}
				/>
				<Route
					path={`${path}/User/:id`}
					render={() => <UserDetails />}
				/>
				<Route
					path={`${path}/Security/Add`}
					exact
					render={props => (
						<PrivilegedView
							pageID='EPIC_ADMINISTRATION_SECURITY_ADD'
							{...permissions}
						>
							<SecurityFormView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route
					path={`${path}/Security/View`}
					exact
					render={props => (
						<PrivilegedView
							pageID='EPIC_ADMINISTRATION_SECURITY_VIEW'
							{...permissions}
						>
							<SecuritySummaryView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route>
					<Redirect to={`${path}/Home`} />
				</Route>
			</Switch>
		</ThemeProvider>
	);
};

export default EpicAdministrationRoutes;
